/* Ist das Fenster so breit wie ein Desktop? (ab 1024 px, wie die Desktop-Regeln in main.css)
 *
 * Nur für Dinge, die sich nicht mit CSS lösen lassen — etwa die Größe eines Bildes, das vom
 * Server in einer passenden Fassung geladen wird (SectorPass). Alles andere am Desktop-Layout
 * steht in @media-Regeln, nicht hier. Der Wert folgt dem Fenster (Drehen, Größe ändern).
 * Ohne Browser (Tests, serverseitiges Rendern) gilt: kein Desktop — also die Handy-Maße.
 */

import { ref } from 'vue';

export const DESKTOP_MIN_WIDTH = 1024;

const isDesktop = ref(false);
let started = false;

function start() {
  if (started || typeof window === 'undefined' || !window.matchMedia) return;
  started = true;
  const mq = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
  isDesktop.value = mq.matches;
  mq.addEventListener('change', (e) => {
    isDesktop.value = e.matches;
  });
}

export function useDesktop() {
  start();
  return { isDesktop };
}
